import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, ArrowUpRight } from "lucide-react";
import { COMPANY, NAV_LINKS, whatsappLink } from "@/data/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#070707] border-t border-white/10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 sm:py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <p className="font-display text-3xl text-cream tracking-tight">
            Waghe <span className="text-gold italic">&amp;</span> Sons
          </p>
          <p className="text-[10px] uppercase tracking-[0.32em] text-zinc-500 mt-2 leading-relaxed">
            Food Pvt. Ltd. · Manufacturers of Premium Indian Namkeen &amp; Snacks
          </p>
          <p className="mt-6 text-sm text-zinc-400 font-light leading-relaxed max-w-sm">
            A family namkeen house from Barwani, Madhya Pradesh — crafting 60+ signature varieties since 1965.
            Waghe Shree for India. Tasty Mint for the world.
          </p>
          <div className="flex gap-4 mt-7">
            <img src="/assets/logo-waghe-shree.jpg" alt="Waghe Shree logo" className="h-16 w-auto rounded-sm border border-white/10" data-testid="footer-logo-shree" />
            <img src="/assets/logo-tasty-mint.jpg" alt="Tasty Mint logo" className="h-16 w-auto rounded-sm border border-white/10" data-testid="footer-logo-mint" />
          </div>
        </div>

        <div className="md:col-span-3">
          <p className="text-xs uppercase tracking-overline text-gold mb-6">Explore</p>
          <ul className="space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                  className="text-sm text-zinc-400 hover:text-gold transition-colors duration-300"
                >
                  {l.label}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/contact#careers" data-testid="footer-link-careers" className="text-sm text-zinc-400 hover:text-gold transition-colors duration-300">
                Careers
              </Link>
            </li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="text-xs uppercase tracking-overline text-gold mb-6">Reach the House</p>
          <ul className="space-y-4 text-sm text-zinc-400">
            <li className="flex gap-3">
              <MapPin className="w-4 h-4 text-gold shrink-0 mt-0.5" />
              <span data-testid="footer-address">{COMPANY.address}</span>
            </li>
            {COMPANY.phones.map((p, i) => (
              <li key={p} className="flex gap-3">
                <Phone className="w-4 h-4 text-gold shrink-0 mt-0.5" />
                <a href={`tel:${COMPANY.phoneRaw[i]}`} data-testid={`footer-phone-${i}`} className="hover:text-gold transition-colors duration-300">
                  {p}
                </a>
              </li>
            ))}
            <li className="flex gap-3">
              <Mail className="w-4 h-4 text-gold shrink-0 mt-0.5" />
              <a href={`mailto:${COMPANY.email}`} data-testid="footer-email" className="hover:text-gold transition-colors duration-300">
                {COMPANY.email}
              </a>
            </li>
          </ul>
          <a
            href={whatsappLink("Namaste Waghe & Sons! I'd like to discuss business.")}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp-button"
            className="mt-7 inline-flex items-center gap-2 border border-gold/50 text-gold text-xs uppercase tracking-[0.14em] px-5 py-3 rounded-sm transition-[transform,background-color,border-color] duration-300 hover:-translate-y-0.5 hover:bg-gold hover:text-ink"
          >
            Chat on WhatsApp <ArrowUpRight className="w-4 h-4" />
          </a>
        </div>
      </div>

      <div className="border-t border-white/10" data-testid="corporate-info">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2">
          <p className="text-[10px] uppercase tracking-[0.28em] text-zinc-600">Corporate Information</p>
          <p className="text-xs text-zinc-500">
            {COMPANY.name} · CIN: <span className="text-zinc-400 tracking-wide" data-testid="footer-cin">U46309MP2026PTCO86682</span> · Barwani, Madhya Pradesh, India
          </p>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-zinc-600">© 2026 {COMPANY.name} All rights reserved.</p>
          <p className="text-[10px] uppercase tracking-[0.28em] text-zinc-600">Made in India · Served Worldwide</p>
        </div>
      </div>
    </footer>
  );
}
